/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JobsSlugRouteImport } from './routes/jobs.$slug'
import { Route as JobsSlugIndexRouteImport } from './routes/jobs.$slug.index'
import { Route as JobsSlugSubmittedRouteImport } from './routes/jobs.$slug.submitted'
import { Route as JobsSlugStatusRouteImport } from './routes/jobs.$slug.status'
import { Route as JobsSlugApplyRouteImport } from './routes/jobs.$slug.apply'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsSlugRoute = JobsSlugRouteImport.update({
  id: '/jobs/$slug',
  path: '/jobs/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsSlugIndexRoute = JobsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => JobsSlugRoute,
} as any)
const JobsSlugSubmittedRoute = JobsSlugSubmittedRouteImport.update({
  id: '/submitted',
  path: '/submitted',
  getParentRoute: () => JobsSlugRoute,
} as any)
const JobsSlugStatusRoute = JobsSlugStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => JobsSlugRoute,
} as any)
const JobsSlugApplyRoute = JobsSlugApplyRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => JobsSlugRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/jobs/$slug': typeof JobsSlugRouteWithChildren
  '/jobs/$slug/apply': typeof JobsSlugApplyRoute
  '/jobs/$slug/status': typeof JobsSlugStatusRoute
  '/jobs/$slug/submitted': typeof JobsSlugSubmittedRoute
  '/jobs/$slug/': typeof JobsSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/jobs/$slug/apply': typeof JobsSlugApplyRoute
  '/jobs/$slug/status': typeof JobsSlugStatusRoute
  '/jobs/$slug/submitted': typeof JobsSlugSubmittedRoute
  '/jobs/$slug': typeof JobsSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/jobs/$slug': typeof JobsSlugRouteWithChildren
  '/jobs/$slug/apply': typeof JobsSlugApplyRoute
  '/jobs/$slug/status': typeof JobsSlugStatusRoute
  '/jobs/$slug/submitted': typeof JobsSlugSubmittedRoute
  '/jobs/$slug/': typeof JobsSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/jobs/$slug'
    | '/jobs/$slug/apply'
    | '/jobs/$slug/status'
    | '/jobs/$slug/submitted'
    | '/jobs/$slug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/jobs/$slug/apply'
    | '/jobs/$slug/status'
    | '/jobs/$slug/submitted'
    | '/jobs/$slug'
  id:
    | '__root__'
    | '/'
    | '/jobs/$slug'
    | '/jobs/$slug/apply'
    | '/jobs/$slug/status'
    | '/jobs/$slug/submitted'
    | '/jobs/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  JobsSlugRoute: typeof JobsSlugRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$slug': {
      id: '/jobs/$slug'
      path: '/jobs/$slug'
      fullPath: '/jobs/$slug'
      preLoaderRoute: typeof JobsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$slug/': {
      id: '/jobs/$slug/'
      path: '/'
      fullPath: '/jobs/$slug/'
      preLoaderRoute: typeof JobsSlugIndexRouteImport
      parentRoute: typeof JobsSlugRoute
    }
    '/jobs/$slug/submitted': {
      id: '/jobs/$slug/submitted'
      path: '/submitted'
      fullPath: '/jobs/$slug/submitted'
      preLoaderRoute: typeof JobsSlugSubmittedRouteImport
      parentRoute: typeof JobsSlugRoute
    }
    '/jobs/$slug/status': {
      id: '/jobs/$slug/status'
      path: '/status'
      fullPath: '/jobs/$slug/status'
      preLoaderRoute: typeof JobsSlugStatusRouteImport
      parentRoute: typeof JobsSlugRoute
    }
    '/jobs/$slug/apply': {
      id: '/jobs/$slug/apply'
      path: '/apply'
      fullPath: '/jobs/$slug/apply'
      preLoaderRoute: typeof JobsSlugApplyRouteImport
      parentRoute: typeof JobsSlugRoute
    }
  }
}

interface JobsSlugRouteChildren {
  JobsSlugApplyRoute: typeof JobsSlugApplyRoute
  JobsSlugStatusRoute: typeof JobsSlugStatusRoute
  JobsSlugSubmittedRoute: typeof JobsSlugSubmittedRoute
  JobsSlugIndexRoute: typeof JobsSlugIndexRoute
}

const JobsSlugRouteChildren: JobsSlugRouteChildren = {
  JobsSlugApplyRoute: JobsSlugApplyRoute,
  JobsSlugStatusRoute: JobsSlugStatusRoute,
  JobsSlugSubmittedRoute: JobsSlugSubmittedRoute,
  JobsSlugIndexRoute: JobsSlugIndexRoute,
}

const JobsSlugRouteWithChildren = JobsSlugRoute._addFileChildren(
  JobsSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  JobsSlugRoute: JobsSlugRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
